/** Edit copy and options here — no need to touch form logic. */
export const EVENT_REGISTRATION_EVENT_SLUG = "schoolup_camp_ux_may2026";

/** Shown in welcome email; keep in sync with `eventBySlug` in pb_hooks/uud_event_registrations.pb.js */
export const EVENT_REGISTRATION_EVENT_TITLE =
  "UUD CAMP — UXデザインプロセスを正しくカスタマイズする";

export const EVENT_REGISTRATION_EVENT_SCHEDULE = "2026年5月30日（土）14:00 – 16:00";

export const EVENT_REGISTRATION_EVENT_PATH = "/camp/event";

export const EVENT_REGISTRATION_MEET_URL = "https://meet.google.com/hau-ysqq-qow";

/** Policy page — same-origin path resolves correctly in new-tab links from the registration form. */
export const PRIVACY_POLICY_URL = "/camp/event/privacy";

export const INQUIRY_TOPICS = [
  "参加について",
  "資料請求",
  "提携・取材",
  "その他",
];

/** 職種 / 役割（contents.md 準拠） */
export const JOB_TITLE_OPTIONS = [
  "プロダクトデザイナー",
  "UXデザイナー",
  "UIデザイナー",
  "グラフィック・ビジュアルデザイナー",
  "その他デザイナー",
  "エンジニア",
  "マネージャー",
  "マーケティング・広報",
  "営業・カスタマーサポート",
  "人事・総務・経理・経営",
  "ファウンダー・役員",
  "学生",
  "その他",
];

export const RADIO_SAMPLE_OPTIONS = [
  { value: "初心者", label: "初心者", icon: "" },
  { value: "学習中", label: "学習中", icon: "" },
  { value: "実務経験あり", label: "実務経験あり", icon: "" },
];

export const CHECKBOX_SAMPLE_OPTIONS = [
  { value: "UXプロセスの全体像を理解したい", label: "UXプロセスの全体像を理解したい", icon: "" },
  { value: "UXプロセスを分かりやすく整理したい", label: "UXプロセスを分かりやすく整理したい", icon: "" },
  { value: "実務でのUXプロセスの使い方を学びたい", label: "実務でのUXプロセスの使い方を学びたい", icon: "" },
  { value: "プロジェクトに合わせた調整方法を知りたい", label: "プロジェクトに合わせた調整方法を知りたい", icon: "" },
  { value: "省略・簡略化の判断基準を知りたい", label: "省略・簡略化の判断基準を知りたい", icon: "" },
  { value: "チームでUXプロセスを改善したい", label: "チームでUXプロセスを改善したい", icon: "" },
  { value: "UX/UIデザインの基礎を学びたい", label: "UX/UIデザインの基礎を学びたい", icon: "" },
  { value: "その他（自由記入）", label: "その他（自由記入）", icon: "" },
];
